module.exports = __webpack_public_path__ + "static/media/270896.cb36eabf.png";